import {Injectable} from '@angular/core';
import {shareReplay} from 'rxjs';
import {NonNullableFormBuilder} from '@angular/forms';
import {EchUtils} from "../ech-utils/ech-utils";

@Injectable()
export class BaseManagementService{
  provinceRegionListObservable: any=[];
  constructor(private echUtils:EchUtils,private fb: NonNullableFormBuilder) {
    this.provinceRegionListObservable = this.echUtils.postObservable("/api/region/getProvinceRegionList")
      .pipe(shareReplay(1));
  }
}
